import AsyncStorage from '@react-native-async-storage/async-storage';
import { init } from '@rematch/core';
import immerPlugin from '@rematch/immer';
import persistPlugin from '@rematch/persist';
import selectPlugin from '@rematch/select';
import autoMergeLevel2 from 'redux-persist/lib/stateReconciler/autoMergeLevel2';

import history from './history';
import wallet from './wallet';

const store = init({
  name: 'wallet',
  models: {
    history,
    wallet,
  },
  plugins: [
    persistPlugin({
      key: 'root',
      storage: AsyncStorage,
      stateReconciler: autoMergeLevel2,
    }),
    immerPlugin(),
    selectPlugin(),
  ],
});

export default store;
